import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import {
  admin,
  call,
  copyIcon,
  gpay,
  otherbg,
  paytm,
  phonepay,
  qrImage,
  wallet,
} from "../../assets/img";
import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import axios from "axios";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";
import { useLocation } from "react-router-dom";
import SubmitButton from "../../Component/SubmitButton";

const Recharge = () => {
  const { kv, set } = useStore();
  const upi = kv.upi_loc;
  const img1 = kv.img1;
  const img2 = kv.img2;

  const [amount, setAmount] = useState("");
  const [trancId, setTrancId] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const [selectedPay, setSelectedPay] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [referralCode, setReferralCode] = useState(upi ?? "");
  const [qrImageUrl, setQrImageUrl] = useState(img1 ? img1 : "");
  const [qrImageUrl2, setQrImageUrl2] = useState(img2 ? img2 : "");
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupImage, setShowPopupImage] = useState(false);
  const [popup, setPopup] = useState(false);
  const [downloadLoading1, setDownloadLoading1] = useState(false);
  const [downloadLoading2, setDownloadLoading2] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          const el = document.querySelector(".dashRightView-foots"); // 👈 your scroll container
          if (el) {
            el.scrollTo({ top: 0, behavior: "smooth" });
          }
        }, 0);
        setAmount("");
        setTrancId("");
        setSelectedPay(null);
        setPopup(false);
        getList();
      }
    }
  }, [location]);

  const getList = async () => {
    try {
      // if (!upi || !img1 || !img2) {
      //   setLoading(true);
      // }
      const res = await get(`${URLS.MASTERALL}`);
      if (res?.status === "success" && Array.isArray(res?.data)) {
        const upiObject = res.data.find((item) => item.type === 2);
        const upiID = upiObject?.data?.upi_id;
        setReferralCode(upiID);
        set("upi_loc", upiID);
        const qrObject = res.data.find((item) => item.type === 1);
        const qrImageOne = qrObject?.data?.image;
        const qrImageTwo = qrObject?.data?.image_two;
        setQrImageUrl(qrImageOne);
        setQrImageUrl2(qrImageTwo);
        set("img1", qrImageOne);
        set("img2", qrImageTwo);
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleCopy = () => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(referralCode)
        .then(() => showCopySuccess())
        .catch(() => fallbackCopy(referralCode));
    } else {
      fallbackCopy(referralCode);
    }
    Toast(`UPI Copied!`);
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      showCopySuccess();
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  const showCopySuccess = () => {
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleDownloadQR = async (url) => {
    if (!url) return;

    try {
      const response = await fetch(
        `https://backend.winnerags.com/api/user/download-qrcode?url=${encodeURIComponent(url)}`,
      );

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "qrcode.png"; // or pdf
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const handleSubmit = async () => {
    if (trancId.length < 10) {
      Toast("Please enter a valid Transaction ID/UTR Number");
      return;
    }
    if (!selectedPay) {
      Toast("Please select a payment method");
      return;
    }

    const payload = {
      method: selectedPay,
      amount: amount,
      transection_id: trancId,
    };
    try {
      setLoading1(true);
      const res = await post(`${URLS.RECHARGE}`, payload);
      if (res?.status === "success") {
        Toast(res.message || "Submitted successfully");
        setAmount("");
        setTrancId("");
        setSelectedPay(null);
        setPopup(false);
      } else {
        Toast(res.message);
      }
    } catch (err) {
      // // console.log("err", err);
    } finally {
      setLoading1(false);
    }
  };

  // Validation: button disabled if amount is invalid, <= 0, or trancId is empty
  const isSubmitDisabled =
    !amount ||
    isNaN(Number(amount)) ||
    Number(amount) <= 0 ||
    !trancId ||
    trancId.length < 10;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="dashRightView-foots ">
      <CustomScroll>
        <div
          style={{ marginBottom: 80 }}
          className=" containers_list container_overalls"
        >
          <p className="f4 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 text-center">
            {" "}
            Scan and Pay{" "}
          </p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div>
              <div
                onClick={() => {
                  setShowPopup(true);
                  setShowPopupImage(qrImageUrl);
                }}
                className=" mt-2 text-center QRCode_container "
              >
                {qrImageUrl ? (
                  <img
                    src={qrImageUrl || qrImage}
                    width={"100%"}
                    height={"100%"}
                  />
                ) : (
                  <>
                    <label
                      htmlFor="qrCodeUpload"
                      className="mt-2 f4 fs-xs-17 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 QRcode sec"
                    >
                      Admin <br /> QR Code
                    </label>
                    <img src={qrImage} width={"100%"} height={"100%"} />
                  </>
                )}
              </div>
              <div className="d-flex ac-jc">
                <button
                  onClick={() => {
                    setDownloadLoading1(true);
                    handleDownloadQR(qrImageUrl).finally(() =>
                      setDownloadLoading1(false),
                    );
                  }}
                  className="QRCode_btn f3 fs-xs-15 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-17 white my-3"
                // style={{ opacity: downloadLoading1 ? 0.5 : 1 }}
                >
                  {/* {downloadLoading1 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: 0.5, position: "relative" }}>
                      Download
                    </span>
                  )} */}
                  <span
                    style={{ top: 0.5, position: "relative", color: "white" }}
                  >
                    Download
                  </span>
                </button>
              </div>
            </div>
            <div>
              <div
                onClick={() => {
                  setShowPopup(true);
                  setShowPopupImage(qrImageUrl2);
                }}
                className=" mt-2 text-center QRCode_container "
              >
                {qrImageUrl2 ? (
                  <img
                    src={qrImageUrl2 || qrImage}
                    width={"100%"}
                    height={"100%"}
                  />
                ) : (
                  <>
                    <label
                      htmlFor="qrCodeUpload"
                      className="mt-2 f4 fs-xs-17 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 QRcode sec"
                    >
                      Admin <br /> QR Code
                    </label>
                    <img src={qrImage} width={"100%"} height={"100%"} />
                  </>
                )}
              </div>
              <div className="d-flex ac-jc">
                <button
                  onClick={() => {
                    setDownloadLoading2(true);
                    handleDownloadQR(qrImageUrl2).finally(() =>
                      setDownloadLoading2(false),
                    );
                  }}
                  className="QRCode_btn  f3 fs-xs-15 fs-sm-12 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-17 white my-3"
                // style={{ opacity: downloadLoading2 ? 0.5 : 1 }}
                >
                  {/* {downloadLoading2 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: 0.5, position: "relative" }}>
                      Download
                    </span>
                  )} */}
                  <span
                    style={{ top: 0.5, position: "relative", color: "white" }}
                  >
                    Download
                  </span>
                </button>
              </div>
            </div>
          </div>

          <p className="f3 weightextra fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 primary mb-2">
            Admin UPI ID
          </p>

          <div
            className="d-flex ac-js w-100 mb-4"
            style={{ alignItems: "center" }}
          >
            <div className="text-center copy-input">
              <input
                type="text"
                style={{ top: isIOS ? -2 : 0, color: "black" }}
                value={referralCode}
                readOnly
              />
            </div>
            <div className="d-flex ac-js position-relative">
            <button
              onClick={handleCopy}
              className="search-btn f3"
                style={{
                  cursor: "pointer", border: "none", top: '-23px',
                  right: '-69px',
                  height: '47px',
                  width:'105px'
                }}
              >
             Copy
            </button>
            </div>
          </div>

          <p className="f3 weightextra fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 primary">
            Select Payment method
          </p>
          <div className=" py-1 d-flex ac-js gap-3">
            <div className="payment">
              <img
                src={gpay}
                alt="GPay"
                className={`upi-icon ${selectedPay === "gpay" ? "selected" : ""}`}
                onClick={() => setSelectedPay("gpay")}
              />
              <img
                src={phonepay}
                alt="PhonePe"
                className={`upi-icon ${selectedPay === "phonepe" ? "selected" : ""
                  }`}
                onClick={() => setSelectedPay("phonepe")}
              />
              <img
                src={paytm}
                alt="Paytm"
                className={`upi-icon ${selectedPay === "paytm" ? "selected" : ""
                  }`}
                onClick={() => setSelectedPay("paytm")}
              />
              <img
                src={otherbg}
                alt="Other"
                className={`upi-icon ${selectedPay === "other" ? "selected" : ""
                  }`}
                onClick={() => setSelectedPay("other")}
              />
            </div>
          </div>
          {selectedPay && (
            <>
              <div className="form-group text-start my-3">
                <p
                  style={{
                    color: !selectedPay ? "#ab5474" : PRIMARY_COLOR,
                  }}
                  className="mb-1 f3 weightextra fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 "
                >
                  Amount
                </p>
                <div style={{ height: 49 }} className="d-flex ac-jb input-box">
                  <input
                    onChange={(e) => setAmount(e.target.value)}
                    type="number"
                    placeholder="Enter Amount"
                    className=""
                    value={amount}
                    onInput={(e) => {
                      if (e.target.value.length > 11) {
                        e.target.value = e.target.value.slice(0, 11);
                      }
                    }}
                    disabled={!selectedPay}
                    placeholderTextColor={!selectedPay ? "#c1c1c1" : "gray"}
                  />
                  <p
                    style={{ fontWeight: 800 }}
                    className="f3 weightextra fs-xs-15 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 "
                  >
                    ₹
                  </p>
                </div>
              </div>
              <div className=" my-3">
                <p
                  style={{
                    color: !selectedPay ? "#ab5474" : PRIMARY_COLOR,
                  }}
                  className="f3 weightextra fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2 "
                >
                  {selectedPay === "phonepe" ? "UTR Number" : "Transaction ID"}
                </p>
                <input
                  className="input-box"
                  name="userName"
                  type="number"
                  style={{ paddingBottom: 14 }}
                  value={trancId}
                  placeholder={
                    selectedPay === "phonepe"
                      ? "Enter UTR Number"
                      : "Enter Transaction ID"
                  }
                  placeholderTextColor={!selectedPay ? "#c1c1c1" : "gray"}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 14) value = value.slice(0, 14);
                    setTrancId(value);
                  }}
                  disabled={!selectedPay}
                />
              </div>

              <div className=" my-3">
                {/* <button
                  onClick={() => setPopup(true)}
                  disabled={isSubmitDisabled || loading1} // ✅ disable button
                  className={`add-button f3 fs-xs-15 fs-sm-12 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 ${isSubmitDisabled ? "disabled-btn" : ""
                    }`}
                  style={{
                    cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                    opacity: !isSubmitDisabled ? 1 : 0.6,
                    color: "#000",
                  }}
                >
                  Confirm Payment
                </button> */}
                <SubmitButton
                  onClick={() => setPopup(true)}
                  title="Confirm Payment"
                  disabled={isSubmitDisabled || loading1}
                  isFormValid={isSubmitDisabled}
                  loading={loading1}
                />
              </div>
            </>
          )}
        </div>
      </CustomScroll>
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowPopup(false)} // close on click outside
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
            onClick={(e) => e.stopPropagation()} // prevent close when clicking image
          >
            {showPopupImage ? (
              <img
                src={showPopupImage}
                alt="QR Code Popup"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 10,
                  boxShadow: "0 0 15px rgba(0,0,0,0.4)",
                }}
              />
            ) : (
              <span style={{ color: "white" }} className="f3">
                QR Not Available
              </span>
            )}
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p style={{ color: "#1B1B1B" }} className="f2">
              Are you sure, you want to confirm to payment ?
            </p>

            <div className="d-flex ac-jb pt-4 f3">
              <button onClick={() => setPopup(false)} className="no-btn w-40">
                No
              </button>

              <button onClick={handleSubmit} className="yes-btn w-40">
                {loading1 ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                ) : (
                  "Yes"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default Recharge;
